export default __webpack_public_path__ + "static/media/ne.6fcdf753.svg";